// extracted by mini-css-extract-plugin
export default {"wrapper":"bfa-z","boldPrefix":"cfa-z","link":"dfa-z","message":"efa-z","image":"ffa-z"};